<template>
	<div class="flex flex-col lg:flex-row lg:gap-20 h-full">
		<div class="m-0 lg:m-20 lg:w-full flex items-center">
			<div class="w-full grid justify-items-center">
				<panel :title="$t('eny.login')" addclass='lg:w-96'>
					<form id="firm-register-form">
						<div class="flex flex-col items-center h-full px-5">
							<div class="w-full pt-5 text-base font-bold">
								<span>{{$t('eny.loginMsg')}}</span>
							</div>
							<div class="pt-2 e-error w-full">{{message}}</div>
							<div class="w-full grow pt-2">
								<div class="pt-5">
									<p class="text-sm">{{$t('eny.firmname')}}*</p>
								</div>
								<div class="pb-5 pt-1 form-group">
									<ejs-maskedtextbox id="name" name="name" floatLabelType="Auto" v-model:value="name"></ejs-maskedtextbox>
									<div class="error-element"></div>
								</div>
								<div class="">
									<p class="text-sm">{{$t('eny.uid')}}*</p>
								</div>
								<div class="pb-5 pt-1 form-group">
									<ejs-maskedtextbox id="uid" name="uid" floatLabelType="Auto" mask='LLL-000.000.000' v-model:value="uid"></ejs-maskedtextbox>
									<div class="error-element"></div>
								</div>
							</div>
							<div class="h-20" />
							<div class="w-full grid justify-items-center pb-4">
								<button type="button" id="register" class="eny-btn-blue text-lg font-bold w-40 my-3 px-6 py-2" @click="register">{{$t('eny.register')}}</button>
							</div>
						</div>
					</form>
				</panel>
			</div>
		</div>
	</div>
</template>
<script>
import { MaskedTextBoxComponent, FormValidator } from "@syncfusion/ej2-vue-inputs";
import Panel from "../Base/Panel.vue";
import { mapGetters } from 'vuex';
export default {
	name: "FirmRegister",
	components: {
		'panel': Panel,
		"ejs-maskedtextbox": MaskedTextBoxComponent,
	},
	mounted() {
		var options = {
			rules: {
				name: { required: [true, this.$t('eny.firm_notempty_error_msg')] },
				uid: { required: [true], regex: ['^[A-Z]{3}-[0-9]{3}.[0-9]{3}.[0-9]{3}$', this.$t('eny.firm_uid_error_msg')] }
			},
			customPlacement: function(element, errorElement) {
				element.closest('.form-group').querySelector('.error-element').appendChild(errorElement);
				// this.$log.debug('FormObject', this.formObject);
			},
		};
		// defines FormValidator to validate the TimePicker
		this.formObject = new FormValidator("#firm-register-form", options);
	},
	data() {
		return {
			name: '',
			uid: 'CHE',
			formObject: '',
		};
	},
	methods: {
		register: function() {
			if (this.formObject.validate()) {
				this.$log.debug('validation', 'passed');
				this.$store.dispatch('firm/checkFirm', {name:this.name, uid:this.uid});
			}
		},
	},
	computed: {
		...mapGetters('firm', ['loading', 'success', 'message']),
	},
	watch: {
		success(value, oldValue) {
			if (value && !oldValue) {
				this.$router.push('/registerDetails/' + this.name +'/uid/' + this.uid);
			}
		}
	}
}
</script>
<style>
	#app .e-input-group {
		@apply border-red-600 border-1 text-sm;
	}
</style>
